import React, { useState, useEffect,useRef } from "react";
import ReactPaginate from "react-paginate";
import axios from 'axios';
import { getUserId } from '../utils/common';
import Modal from './Modal';
import ModalSale from './ModalSale';
import AddSale from './AddSaleM';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {aPIURL,auTHURL} from '../utils/common';
import { useReactToPrint } from 'react-to-print';
import { useDownloadExcel } from "react-export-table-to-excel";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';


const DeviceSale = () => {

  const fileType ="xlsx";
  const tableRef = useRef(null);
  const divRef = useRef(null);
  const API_URL=aPIURL();
  const [post, setPost] = useState([]);
  const [order, setOrder] = useState("ASC");
  const [number, setNumber] = useState(1); 
  const [postPerPage] = useState(10);
  const [showAddSaleDevice, setShowAddSaleDevice]= useState(false);
  const [showDetails, setShowDetails]= useState(false);
  const [editDetails, setEditDetails]= useState(false);
  const [inputs, setInputs] = useState({});
  const [customerData, setCustomerData]= useState([]);
  const [custID, setCustID]=useState(0);
  const [subscriptionData,setSubscriptionData]= useState([]);
  const [saleSubscriptionTypeID, setSaleSubscriptionTypeID]=useState(0);
  const [dModel, setDModel]=useState("0");
  const [devicestock, setDevicestock]=useState(0);
  const [filteredSaleDeviceDetails,setFilteredSaleDeviceDetails]= useState([]);
  const [saleDeviceData,setSaleDeviceData]= useState([]);
  const [deviceCost,setdeviceCost]=useState(0);
   
  const [inputsEdit, setInputsEdit] = useState({});
  const [cGstPer, setCGstPer]=useState(0);
  const [sGstPer, setSGstPer]=useState(0);
  const [iGstPer, setIGstPer]=useState(0);
  const [cGstVal, setCGstVal]=useState(0.00);
  const [sGstVal, setSGstVal]=useState(0.00);
  const [iGstVal, setIGstVal]=useState(0.00);
  let [payableAmount,setPayableAmount]=useState(0.00);
  let [gTotalVal, setGTotalVal]=useState(0.00);
  let [totAmount,setTotAmount]=useState(0.00);
  let [discountVal, setDiscountVal]=useState(0.00);
  let [insChargeVal, setInsChargeVal]=useState(0.00);
  const [invoiceID,setInvoiceID]=useState(0);
  const [cDisplay, setCDisplay]= useState('none');
  let [paymentStatusId, setPaymentStatusId] = useState(0);
  let [custName , setCustName]= useState('');   
  let [fCustName , setFCustName]= useState('NA'); 

useEffect(() => {
      
    FillGrid(0);  

    }, []);
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);
  let rc=1;

const ChangePage = ({ selected }) => {
        
        setNumber(selected+1);
  };

const showDetailsModal = (index) => {  

    const invoice_ID = index;   
    setShowDetails(true);           
    const updatedDeviceList = post.filter((custElem) => {          
    
    return custElem.invoiceID === invoice_ID;

  });
   
  setFilteredSaleDeviceDetails(updatedDeviceList);   

   const dcurls=API_URL+`GpsSoldDevicebyId/${invoice_ID}/`;  
   
   axios.get(dcurls).then(response => 
    {                            
      setSaleDeviceData(response.data.data);
        
    }).catch(function(error) { console.log(error.message); });  

}
const handleEdit=(index) => {

  setCDisplay('none');
  setInvoiceID(index);
  const invoice_ID = index;   
  setEditDetails(true);
  const updatedDeviceList = post.filter((custElem) => {   return custElem.invoiceID === invoice_ID;  });
  inputsEdit.deviceCost = updatedDeviceList[0].price;
  inputsEdit.grandTotal= updatedDeviceList[0].grandTotal;
  console.log(updatedDeviceList);
  setDiscountVal(updatedDeviceList[0].discount); 
  setInsChargeVal(updatedDeviceList[0].installationCharge);
  setCGstPer(updatedDeviceList[0].cgstPer);
  setCGstVal(updatedDeviceList[0].cgstVal);
  setSGstPer(updatedDeviceList[0].sgstPer);
  setSGstVal(updatedDeviceList[0].sgstVal);
  setIGstPer(updatedDeviceList[0].igstPer);
  setIGstVal(updatedDeviceList[0].igstVal);
  setTotAmount(parseFloat(updatedDeviceList[0].price)*1.00);
  setPayableAmount(parseFloat(updatedDeviceList[0].price)*1.00);  
  setGTotalVal(parseFloat(updatedDeviceList[0].grandTotal)*1.00);  
  setFilteredSaleDeviceDetails(updatedDeviceList);  
 
  const dcurls=API_URL+`GpsSoldDevicebyId/${invoice_ID}/`;  
    
  axios.get(dcurls).then(response => 
  {                            
      setSaleDeviceData(response.data.data);
     
  }).catch(function(error) { console.log(error.message); });  
}

const sorting=(col)=>
{
  try
  {
    if(order==="ASC")
    {
            const sorted=[...post].sort((a,b)=>
            a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
            );
            setPost(sorted);
            setOrder("DSC");
    }
    if(order==="DSC")
    {
            const sorted=[...post].sort((a,b)=>
            a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
            );
            setPost(sorted);
            setOrder("ASC");
    }
  }
  catch(error) 
  {
    console.log(error.message);
  }            
}

const FillGrid=(Type_ID)=>
{
   const curls=API_URL+`GpsSoldDeviceAllList/?TypeID=${Type_ID}`;  
   setPost([]);
   axios.get(curls).then(response => 
    {                            
        setPost(response.data.data);
        console.log(response.data.data);
        setDevicestock(25);
    }).catch(function(error) { console.log(error.message); });     
    
}
const showAddSaleDeviceDetails=()=>
{
    setShowAddSaleDevice(true);
    const cstUsl=API_URL+`GpsSaleCustomerList/?TypeID=0`;
    axios.post(cstUsl).then(response => {
    
    console.log(response.data.data);

      const updatedCustomerList = response.data.data.filter((curElem) => {
            return curElem.status === "Active" && curElem.parentId===0;
     });
             setCustomerData(updatedCustomerList); 
    }).catch(function(error) { console.log(error.message); });  

    axios.get(API_URL+'Subscribe').then(response => {      
               setSubscriptionData(response.data.data);  
    }).catch(function(error) { console.log(error.message); });  

}
const closeAddSaleModal=()=>
{
        setShowAddSaleDevice(false);
        FillGrid(0);   
}
const closeShowDetailModal=()=>
{
        setShowDetails(false);
        setEditDetails(false);
        FillGrid(0);   
}
const ChangeCustomerID = (e) => {

         setCustID(e.target.value);    
}
const ChangeSubscriptionType=(e)=>
{
         setSaleSubscriptionTypeID(e.target.value);
}
const ChangeDMode=(e)=>
{
         setDModel(e.target.value);   
}
const ChangepaymentStatusHandler = e => {
      const value = e.target.value;
      setPaymentStatusId(e.target.value);      
}
const CustNamechangeHandler=(e)=>
{
      setCustName(e.target.value);
      setFCustName(e.target.value);
}
const FilterGrid=()=>
  {
      setPost([]);
      const curlsadv=API_URL+`GpsSoldDeviceAllListAdv/?TypeID=${paymentStatusId}&CustName=${fCustName}`;
      //alert(curlsadv);
      axios.get(curlsadv).then(response => 
      {                            
         setPost(response.data.data);       
        
      }).catch(function(error)
      {
         console.log(error.message);
      });         
  }
const ResetList=()=>
  {
       FillGrid(0);
       setCustName('');
       setFCustName('NA');
       setPaymentStatusId(0);
    
  }
const changeVHandler = (event) => {

  const name = event.target.name;  
  const value = event.target.value;

  if(event.target.name==='deviceCost')
  {
        setCDisplay('block');
        setTotAmount(parseFloat(event.target.value)*1.00);  
        setPayableAmount(parseFloat(event.target.value)*1.00);  
        setGTotalVal(parseFloat(event.target.value)*1.00);
        setCGstPer(0);
        setSGstPer(0);
        setIGstPer(0);
        setCGstVal(0.00);
        setSGstVal(0.00);
        setIGstVal(0.00);
        setDiscountVal(0.00);
        setInsChargeVal(0.00);          
        inputsEdit.grandTotal=event.target.value;
        setInputsEdit(values => ({...values, [name]: value}))
        
  }
  else if(event.target.name==='gtotal')
  {
        setGTotalVal(parseFloat(event.target.value)*1.00);
        setInputsEdit(values => ({...values, [name]: value}))
        inputsEdit.grandTotal=event.target.value;
  }
  else if(event.target.name==='ddiscount')
  {
            setCGstPer(0);
            setSGstPer(0);
            setIGstPer(0);
            setCGstVal(0.00);
            setSGstVal(0.00);
            setIGstVal(0.00);
            setDiscountVal(event.target.value);
            setInsChargeVal(0.00);
            setGTotalVal((parseFloat(totAmount,2)  - event.target.value) + parseFloat(insChargeVal,2) + parseFloat(cGstVal,2)+ parseFloat(sGstVal,2)+ parseFloat(iGstVal,2)); 
            inputsEdit.grandTotal=(parseFloat(totAmount,2)  - event.target.value) + parseFloat(insChargeVal,2) + parseFloat(cGstVal,2)+ parseFloat(sGstVal,2)+ parseFloat(iGstVal,2);
            setPayableAmount((parseFloat(totAmount,2)  - event.target.value) + parseFloat(insChargeVal,2));   
  }
 else if(event.target.name==='installationcharge')
 {
            setSGstPer(0);
            setCGstPer(0);
            setIGstPer(0);
            setCGstVal(0.00);
            setSGstVal(0.00);
            setIGstVal(0.00);
            setInsChargeVal(event.target.value);
            setGTotalVal((parseFloat(totAmount,2) - parseFloat(discountVal,2)) + parseFloat(event.target.value)+ parseFloat(cGstVal,2)+ parseFloat(sGstVal,2)+ parseFloat(iGstVal,2));
            inputsEdit.grandTotal=(parseFloat(totAmount,2) - parseFloat(discountVal,2)) + parseFloat(event.target.value)+ parseFloat(cGstVal,2)+ parseFloat(sGstVal,2)+ parseFloat(iGstVal,2);
            setPayableAmount((parseFloat(totAmount,2)  - parseFloat(discountVal,2)));
 }
 else
  {
        setInputsEdit(values => ({...values, [name]: value}))
  }    
}


const exportToCSV=()=>
  {
    const newPost = post.map(({ cgstPer,cgstVal,currency,dueDate,igstPer,igstVal,invDetailID,renewalDate,sgstPer,sgstVal,subscriptionDuration,terms,price, ...rest }) => rest);
     const ws= XLSX.utils.json_to_sheet(newPost);        
     var wscols = [
        {wch:5} ,
        {wch:15},
        {wch:30},
        {wch:15},
        {wch:10},
        {wch:10},
        {wch:20},   
        {wch:20}, 
        {wch:20},  
        {wch:20}
    ];
 
    var wsrows = [
       {hpx: 30}
    ];
    
    ws['!cols'] = wscols;
    ws['!rows']=wsrows;
         
    let Heading = [['S.No.','Invoice ID','Customer Name','Invoice Date','Model','Quantity','Total Amount','Discount','Installation Charge','Grand Total']];
    const wb={Sheets:{DeviceSale:ws},SheetNames:["DeviceSale"]};
    XLSX.utils.sheet_add_aoa(ws, Heading);     
    const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
    const data= new Blob([excelBuffer],{type:fileType});
    FileSaver.saveAs(data,"AvtDeviceSaleReport"+".xlsx");
   }
const ChangeCGST=(e)=>
{
    setCGstPer(e.target.value);     
    setCGstVal(parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00));
    setGTotalVal(parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) +  parseFloat(sGstVal,2) + parseFloat(iGstVal,2) + parseFloat(insChargeVal,2));
    inputsEdit.grandTotal=parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) +  parseFloat(sGstVal,2) + parseFloat(iGstVal,2) + parseFloat(insChargeVal,2);
}
const ChangeSGST=(e)=>
{
    setSGstPer(e.target.value);     
    setSGstVal(parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00));
    setGTotalVal(parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) + parseFloat(cGstVal,2) +  parseFloat(iGstVal,2)+ parseFloat(insChargeVal,2));
    inputsEdit.grandTotal=parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) + parseFloat(cGstVal,2) +  parseFloat(iGstVal,2) + parseFloat(insChargeVal,2);
}
const ChangeIGST=(e)=>
{
    setIGstPer(e.target.value);     
    setIGstVal(parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00));
    setGTotalVal(parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) + parseFloat(cGstVal,2)+ parseFloat(sGstVal,2)+ parseFloat(insChargeVal,2));
    inputsEdit.grandTotal=parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) + parseFloat(cGstVal,2)+ parseFloat(sGstVal,2)+ parseFloat(insChargeVal,2);
}

const SaleUpdate=()=>
{
            const sparams = JSON.stringify({
            "InvoiceID": parseInt(invoiceID), 
            "customerID": 1,
            "invoiceDate": '2026-01-01',
            "model": 'GPS-V5',
            "subscriptionDuration": 1,
            "currency": "INR",
            "terms": 1,
            "dueDate": '01-01-2026',
            "price": parseInt(inputsEdit.deviceCost),
            "stock": devicestock,
            "quantity": '1',
            "totalAmount": totAmount.toString() ,
            "discount": parseInt(discountVal).toString(),
            "installationCharge": parseInt(insChargeVal).toString(),
            "cgstPer": parseInt(cGstPer),
            "cgstVal": cGstVal.toFixed(2),
            "sgstPer": parseInt(sGstPer),
            "sgstVal": sGstVal.toFixed(2),
            "igstPer": parseInt(iGstPer),
            "igstVal": iGstVal.toFixed(2),
            "grandTotal": gTotalVal.toFixed(2),
            "invoiceType": "Update Sale"           
        });
        
        axios.post(API_URL+'GPSDeviceSaleInsert', sparams, { "headers": {  "content-type": "application/json",  },   })
        .then(function (response) 
        {
                     if(!response.data.validStatus)
                     {
                          toast.error(response.data.message);                                                                 
                     }
                     else
                     {
                          toast.success(response.data.message);                                                       
                     }      
        })
        .catch(function (error) 
        {
                   toast.error("Some Error occured while updating sale device record,Please Provide Valid Inputs.");                  
                   console.log(error.message);    
        });
        //GPSDevice Sale Insert ends   
}
const exportDownload = e => 
{  
    const value = e.target.value; 
    if(value=="Excel")
    {
        exportToCSV();       
    } 
    if(value=="PDF")
    {
        handlePrint(null, () => tableRef.current);
    }
}

const printInvoice=()=>
{
      handlePrint(null, () => divRef.current);
}

const handlePrint = useReactToPrint({
documentTitle: "Device Details",
onBeforePrint: () => console.log("before printing..."),
onAfterPrint: () => console.log("after printing..."),
removeAfterPrint: true,
});

  return (
    <>
      <ModalSale isOpen={showAddSaleDevice} style={{height:"850px!important"}}>
        <>
            <div class="modal-header">
            <h5 className='modal-title'>Add Sale</h5>
            <button type="button" class="btn-close" onClick={closeAddSaleModal}></button>
            </div>
            <div class="modal-body">
              <AddSale/>
            </div>                    
        </>
      </ModalSale> 
      <ModalSale isOpen={showDetails} style={{height:"800px!important"}}>
      <>
          <div class="modal-header">
            <h5 className='modal-title'>Sale Details</h5>
            {/*<button type="button" onClick={() => printInvoice()}>Print</button>*/}
            <button type="button" class="btn-close" onClick={closeShowDetailModal}></button>
          </div>
          <div ref={divRef} class="modal-body">
          
          {filteredSaleDeviceDetails.map(devdata1 => (<div className='row' key={devdata1.invoiceID}>
           
            <div className='col-md-6 col-lg-3 form-group'>
                           <b>Invoice No :</b> {devdata1.invDetailID}                           
                             </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Invoice Date :</b> {devdata1.invoiceDate}                            
                            </div>
                            <div className='col-md-6 col-lg-6 form-group'>
                            <b>Customer Name :</b> {devdata1.customerName}                                                       
                            </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Model :</b> {devdata1.model}                            
                            </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Subscription Duration :</b> {devdata1.subscribeName} 
                            </div>
                            
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Terms :</b> {devdata1.terms} days
                            </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Due Date :</b> {devdata1.dueDate}                            
                            </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Price Per Device :</b> {devdata1.price} {devdata1.currency} 
                            </div>                            
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Quantity :</b> {devdata1.quantity}
                            </div>  
                           
            </div>
             ))}
          
            <div className="row" style={{ padding:"5px" }} >
           
            <table id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
            <thead>
            <tr>
                    <th style={{ textAlign: "center"}} width="5%">S.No.</th>
                    <th style={{ textAlign: "center"}} width="10%">Device ID</th>
                    <th style={{ textAlign: "center"}} width="35%">Name</th>
                    <th style={{ textAlign: "center"}} width="20%">IMEI#</th>
                    <th style={{ textAlign: "center"}} width="20%">SIM#</th>                 
                                      
            </tr>
            </thead>
            <tbody>
                {saleDeviceData.map(item => (
                  
                <tr key={item.id}>
                  <td style={{ textAlign: "center"}}> {item.sno}</td>
                  <td style={{ textAlign: "center"}}>{item.id}</td>
                  <td>{item.deviceName}</td>
                  <td>{item.imeiNumber}</td>
                  <td style={{ textAlign: "center"}}> {item.mobileNumber} </td>
                  
                  <td style={{"display":"none"}}>{rc++}    </td>     
                </tr>
                 
                    ))}                
            </tbody>
            </table>
            </div>
            {filteredSaleDeviceDetails.map(devdata1 => (<div className='row' key={devdata1.invoiceID}>
           
                           <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>Total Amount :</b> 
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                             {devdata1.totalAmount}
                            </div> 
                            <div className='col-md-6 col-lg-1 form-group' ></div> 
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>Discount :</b> 
                            </div> 
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                            {devdata1.discount}
                            </div> 
                            <div className='col-md-6 col-lg-1 form-group' ></div>
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>Installation Charge :</b> 
                            </div>   
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                            {devdata1.installationCharge}
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' ></div>
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>CGST :</b>&nbsp;&nbsp;({devdata1.cgstPer}%) 
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                             {devdata1.cgstVal}
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' ></div>
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>SGST :</b>&nbsp;&nbsp;({devdata1.sgstPer}%) 
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                            {devdata1.sgstVal}
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' ></div>
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>IGST :</b>&nbsp;&nbsp;({devdata1.igstPer}%) 
                            </div>   
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                            {devdata1.igstVal}
                            </div>   
                            <div className='col-md-6 col-lg-1 form-group' ></div>
                            <hr/>
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>Grand Total :</b> 
                            </div>                             
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                            <b>{devdata1.grandTotal}</b>
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"left"}}></div>                         
            </div>
             ))}
 
          </div>                    
        </>
      </ModalSale>  
      <ModalSale isOpen={editDetails} style={{height:"800px!important"}}>
      <>
          <div class="modal-header">
          <h5 className='modal-title'>Edit Sale Details</h5>
          <button type="button" class="btn-close" onClick={closeShowDetailModal}></button>
          </div>
          <div ref={divRef} class="modal-body">          
          {filteredSaleDeviceDetails.map(devdata1 => (<div className='row' key={devdata1.invoiceID}>
          <div className='col-md-6 col-lg-3 form-group'>
          <b>Invoice No :</b> {devdata1.invDetailID}                           
                             </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Invoice Date :</b> {devdata1.invoiceDate}                            
                            </div>
                            <div className='col-md-6 col-lg-6 form-group'>
                            <b>Customer Name :</b> {devdata1.customerName}                                                       
                            </div>                            
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Subscription Duration :</b> {devdata1.subscribeName} 
                            </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Terms :</b> {devdata1.terms} days
                            </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Due Date :</b> {devdata1.dueDate}                            
                            </div>                            
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Quantity :</b> {devdata1.quantity}
                            </div>                     
          </div>
          ))}
          <div className="row" style={{ padding:"5px" }} >
          <table id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
          <thead>
          <tr>
                    <th style={{ textAlign: "center"}} width="5%">S.No.</th>
                    <th style={{ textAlign: "center"}} width="10%">Device ID</th>
                    <th style={{ textAlign: "center"}} width="35%">Name</th>
                    <th style={{ textAlign: "center"}} width="20%">IMEI#</th>
                    <th style={{ textAlign: "center"}} width="20%">SIM#</th>        
          </tr>
          </thead>
          <tbody>
          {saleDeviceData.map(item => (
          <tr key={item.id}>
                  <td style={{ textAlign: "center"}}> {item.sno}</td>
                  <td style={{ textAlign: "center"}}>{item.id}</td>
                  <td>{item.deviceName}</td>
                  <td>{item.imeiNumber}</td>
                  <td style={{ textAlign: "center"}}> {item.mobileNumber} </td>
                  <td style={{"display":"none"}}>{rc++} </td>     
                </tr>                 
          ))}                
          </tbody>
          </table>
          </div>
          {filteredSaleDeviceDetails.map(devdata1 => (<div className='row' key={devdata1.invoiceID}>
                            <div className='col-md-6 col-lg-8 form-group'></div>
                            <div className='col-md-6 col-lg-2 form-group'><b>Total Amount :</b>                              
                            </div>  
                            <div className='col-md-6 col-lg-2 form-group' style={{textAlign:"right"}}>
                            <input name="deviceCost"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={inputsEdit.deviceCost}  onChange={changeVHandler}/>
                            </div>                            
                            
                            <div className='col-md-6 col-lg-8 form-group'></div>
                            <div className='col-md-6 col-lg-2 form-group'><b>Discount :</b></div> 
                            <div className='col-md-6 col-lg-2 form-group' style={{textAlign:"right"}}>
                            <input name="ddiscount"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={discountVal}  onChange={changeVHandler}/>
                            </div>

                            <div className='col-md-6 col-lg-8 form-group'></div>
                            <div className='col-md-6 col-lg-2 form-group'><b>Installation Charge :</b></div>   
                            <div className='col-md-6 col-lg-2 form-group' style={{textAlign:"right"}}>
                           <input name="installationcharge"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={insChargeVal}  onChange={changeVHandler}/>
                            </div>  

                            <div className='col-md-6 col-lg-8 form-group' style={{textAlign:"right"}}><b>CGST% :</b></div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <select className="form-control" name="cgst"   style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px", "padding": "5px 5px"}} value={cGstPer} onChange={ ChangeCGST }  >
                            <option value={0}>Select</option> 
                            <option value={9}>9%</option>   
                            <option value={18}>18%</option>        
                            </select>
                            </div>  
                            <div className='col-md-6 col-lg-2 form-group' style={{textAlign:"right"}}>
                            <input name="cgst"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={cGstVal}  onChange={changeVHandler}/>
                            </div>  
                            
                            <div className='col-md-6 col-lg-8 form-group' style={{ textAlign:"right"}}><b>SGST% :</b></div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <select className="form-control" name="sgst"   style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px", "padding": "5px 5px"}} value={sGstPer}  onChange={ ChangeSGST } >
                            <option value={0}>Select</option> 
                            <option value={9}>9%</option>   
                            <option value={18}>18%</option>           
                            </select> 
                            </div>  
                            <div className='col-md-6 col-lg-2 form-group' style={{textAlign:"right"}}>
                            <input name="sgst"  type="text"  maxLength={5} className="form-control" style={{textAlign:"right"}} value={sGstVal}  onChange={changeVHandler} />
                            </div>  

                            <div className='col-md-6 col-lg-8 form-group' style={{ textAlign:"right"}}><b>IGST% :</b></div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <select className="form-control" name="igst" style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px", "padding": "5px 5px"}} value={iGstPer}  onChange={ ChangeIGST }  >
                            <option value={0}>Select</option> 
                            <option value={9}>9%</option>   
                            <option value={18}>18%</option>              
                            </select>
                            </div>   
                            <div className='col-md-6 col-lg-2 form-group' style={{textAlign:"right"}}>
                            <input name="igst"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={iGstVal}  onChange={changeVHandler}/>
                            </div>                             
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>Grand Total :</b> 
                            </div>                            
                            <div className='col-md-6 col-lg-2 form-group' style={{textAlign:"right"}}>
                            <input name="gtotal"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={ inputsEdit.grandTotal }  onChange={changeVHandler}/>
                            </div>    
                              
                            <div class="modal-footer justify-content-right" style={{"text-align": "center" , display: cDisplay }}>
                            <button className="btn btn-primary2" onClick={() => SaleUpdate()}>Update</button> 
                            </div>                                                    
            </div>            
          ))}
          </div>                    
        </>
      </ModalSale>  
 <div className="top-bar clearfix">
 <div className="row">
 <div className="col-md-4"><h2> Sale Device</h2></div>
 <div className="col-md-8 text-right">
      <button type="submit" id="AddSale" onClick={() => showAddSaleDeviceDetails()} className="btn btn-new"> New </button>  
      <select onChange={exportDownload} className="btn btn-primary">
      <option value={"Download"}>Download</option>    
      <option value={"Excel"}>Excel</option>    
      <option value={"PDF"}>PDF</option>                      
      </select>
 </div>
 </div> 
 </div>
  <div className="container-fluid p-3">
  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
  <div class="row align-items-end">  
  <div class="col-sm-3 col-lg-2">Status 
  <select onChange={ChangepaymentStatusHandler} class="form-control" value={paymentStatusId} name="PaymentStatusId">
  <option value={"0"}>All</option>    
  <option value={"1"}>Pending</option>  
  <option value={"2"}>Partial Paid</option>     
  <option value={"3"}>Paid</option>             
  </select>
  </div>
  <div class="col-sm-3 col-lg-2">CUSTOMER NAME <input type="text" class="form-control" tabindex="1" id="txtCustomerName"   maxlength="50" value={custName} onChange={CustNamechangeHandler}/>
  </div>
  <div class="col-sm-4 col-lg-2">
  <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnSearchNew" onClick={FilterGrid} >Search</button>
  <button type="button" class="btn btn-secondary mt-20" id="btnResetNew" tabindex="4" onClick={ResetList}>Reset
  </button></div>
  <div class="col-sm-3 col-lg-2"> </div> 
  <div class="col-sm-3 col-lg-2"> </div>
  </div></div></div></div>
    <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div class="card-body p-0">
    <table ref={tableRef} id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
    <thead>
    <tr>
                    <th width="3%" >S.No.</th>
                    <th onClick={()=>sorting("invDetailID") } style={{textAlign:"center","cursor": "pointer"}} width="10%">Invoice No &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("customerName") } style={{textAlign:"center","cursor": "pointer"}} width="14%">Customer Name &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("invoiceDate") } style={{textAlign:"center","cursor": "pointer"}} width="8%">Invoice Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("quantity") } style={{textAlign:"center","cursor": "pointer"}} width="7%">Quantity &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("model") } style={{textAlign:"center","cursor": "pointer"}} width="7%">Model &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("totalAmount") } style={{textAlign:"center","cursor": "pointer"}} width="8%">Total Amount &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("discount") } style={{textAlign:"center","cursor": "pointer"}} width="7%">Discount &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("installationCharge") } style={{textAlign:"center","cursor": "pointer"}} width="9%">Inst. Charge &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("grandTotal") } style={{textAlign:"center","cursor": "pointer"}} width="10%">Grand Total &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("paymentStatus") } style={{textAlign:"center","cursor": "pointer"}} width="10%"> Status &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th style={{textAlign:"center"}} width="7%">Action</th>
    </tr>
    </thead>
    <tbody>
    {currentPost.map((item) => {
                return (
                <tr key={item.invoiceID}>
                  <td style={{textAlign:"center"}}>{item.sNo}</td>
                  <td style={{textAlign:"center"}}>{item.invDetailID}</td>
                  <td>{item.customerName}</td>
                  <td style={{textAlign:"center"}}>{item.invoiceDate}</td>
                  <td style={{textAlign: "center"}}>{item.quantity}</td>
                  <td style={{textAlign:"center"}}>{item.model}</td>
                  <td style={{textAlign:"center"}}>{item.totalAmount}</td>
                  <td style={{textAlign:"center"}}>{item.discount}</td>
                  <td style={{textAlign:"center"}}>{item.installationCharge}</td>
                  <td style={{textAlign:"center"}}>{item.grandTotal}</td>                  
                  <td style={{textAlign:"center"}}>{item.paymentStatus}</td>
                  <td style={{textAlign:"center", fontSize:"16px"}}>
                  <i onClick={() => showDetailsModal(item.invoiceID)} style={{ color:"green", cursor:'pointer'}} className="fas fa-list" title="View Details"></i>
                  &nbsp;&nbsp; <i onClick={() => handleEdit(item.invoiceID)} style={{ color:"#fd0691", cursor:'pointer'}} className="fa-solid fa-pen-to-square" title="Update Details"></i>
                  </td>
                </tr>
               );
              })}                 
                </tbody>
            </table>
            <ReactPaginate previousLabel={"<<"} nextLabel={">>"} pageCount={PageCount}
            onPageChange={ChangePage} disableInitialCallback={true} initialPage={0} containerClassName={'pagination justify-content-end'}
            pageClassName={'page-item'} pageLinkClassName={'page-link'} previousClassName={'page-item'} previousLinkClassName={'page-link'}  nextClassName={'page-item'}
            nextLinkClassName={'page-link'} breakClassName={'page-item'} breakLinkClassName={'page-link'} activeClassName={'active'}>
            </ReactPaginate>
        </div>
      </div></div>
      <ToastContainer position="bottom-right" autoClose={4000} theme="light"/> 
    </>
  );
};
export default DeviceSale;